import { gsap } from "gsap";

const navigationToggle = () => {
	const toggle = document.querySelector(".jbg-nav-toggle");
	const main = document.querySelector("body main");

	let isOpen = false;
	let wasResizedWhileOpen = false;
	let scrollPosition = 0;

	// Track resize while nav is open
	window.addEventListener("resize", () => {
		if (isOpen) wasResizedWhileOpen = true;
	});

	toggle.addEventListener("click", () => {
		isOpen = !isOpen;

		if (isOpen) {
			// Save scroll position before hiding layout
			scrollPosition = window.scrollY;

			document.body.classList.add("jbg-primary-nav__offcanvas-show");
			gsap.set(main, { display: "none", delay: 0.55 });
		} else {
			gsap.set(main, { display: "block", opacity: 0 });

			if (wasResizedWhileOpen) {
				void main.offsetHeight;
				window.dispatchEvent(new Event("resize"));
			}

			// Restore scroll position after layout is back
			window.scrollTo(0, scrollPosition);

			gsap.to(main, { opacity: 1, duration: 0.1, delay: 0.15 });
			document.body.classList.remove("jbg-primary-nav__offcanvas-show");
			wasResizedWhileOpen = false;
		}
	});
};

export default navigationToggle;
